"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _allTemplates = require("../../../allTemplates.js");
var _helpers = require("../../../other/helpers.js");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = ['showOneElementPerPage', 'showRequiredState', 'showQuestionNumbers', 'showAdvancedSettings', 'playerTemplate', 'playerTemplateSettings', 'overrideAccommodations', 'accommodations.masking', 'accommodations.highlighting', 'accommodations.autoplayQuestions', 'accommodations.autoplayChoices', 'accommodations.autoplayInstructions', 'accommodations.blockUserInteractions'];
var validate = function validate(values) {
  var errors = {};
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getTemplateList", function () {
      var flowType = _this.props.settings.type;
      if (!flowType) {
        return [];
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      return (0, _allTemplates.getTemplateList)('players', flowTypeInfo.playerType);
    });
    _defineProperty(_assertThisInitialized(_this), "_onTemplateChange", function (event) {
      var _this$props$fields = _this.props.fields,
        playerTemplate = _this$props$fields.playerTemplate,
        playerTemplateSettings = _this$props$fields.playerTemplateSettings;
      var newTemplateName = event.target.value;
      var availableTemplates = _this._getTemplateList();
      var newTemplate = (0, _find2["default"])(availableTemplates, {
        name: newTemplateName
      });
      var newTemplateSettings = newTemplate ? newTemplate.defaultSettings : {};
      playerTemplate.onChange(newTemplateName);
      playerTemplateSettings.onChange(newTemplateSettings);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTemplateBlock", function () {
      var _this$props$fields2 = _this.props.fields,
        playerTemplate = _this$props$fields2.playerTemplate,
        playerTemplateSettings = _this$props$fields2.playerTemplateSettings;
      var availableTemplates = _this._getTemplateList();
      var templateSettingsComponent = null;
      var currentTemplate = (0, _find2["default"])(availableTemplates, {
        name: playerTemplate.value
      });
      if (currentTemplate && currentTemplate.settingsComponent) {
        var SettingsComponent = currentTemplate.settingsComponent;
        templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
          initialValues: _objectSpread(_objectSpread({}, currentTemplate.defaultSettings), playerTemplateSettings.value),
          onChange: playerTemplateSettings.onChange
        });
      }
      var showTemplateSelectbox = availableTemplates.length > 1;

      // Don't show FormBlock for default template as it has many others form blocks
      if (!showTemplateSelectbox && playerTemplate.value === 'default') {
        return templateSettingsComponent;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Player style",
        show: true,
        type: "primary"
      }, showTemplateSelectbox && /*#__PURE__*/_react["default"].createElement("div", {
        className: !templateSettingsComponent ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: playerTemplate,
        label: "Template"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(playerTemplate), {
        className: "form-select",
        style: {
          width: 'auto'
        },
        onChange: _this._onTemplateChange
      }), availableTemplates.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: item.name,
          key: item.name
        }, item.title);
      })))), templateSettingsComponent);
    });
    _defineProperty(_assertThisInitialized(_this), "_changeOverrideAccommodations", function (event) {
      var _this$props$fields3 = _this.props.fields,
        overrideAccommodations = _this$props$fields3.overrideAccommodations,
        _this$props$fields3$a = _this$props$fields3.accommodations,
        masking = _this$props$fields3$a.masking,
        highlighting = _this$props$fields3$a.highlighting,
        autoplayQuestions = _this$props$fields3$a.autoplayQuestions,
        autoplayChoices = _this$props$fields3$a.autoplayChoices,
        autoplayInstructions = _this$props$fields3$a.autoplayInstructions,
        blockUserInteractions = _this$props$fields3$a.blockUserInteractions;
      var list = [masking, highlighting, autoplayQuestions, autoplayChoices, autoplayInstructions, blockUserInteractions];
      overrideAccommodations.onChange(event);
      list.forEach(function (item) {
        return !item.value && item.onChange(false);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPlayerBlock", function () {
      var _this$props = _this.props,
        _this$props$fields4 = _this$props.fields,
        showOneElementPerPage = _this$props$fields4.showOneElementPerPage,
        showRequiredState = _this$props$fields4.showRequiredState,
        showQuestionNumbers = _this$props$fields4.showQuestionNumbers,
        showAdvancedSettings = _this$props$fields4.showAdvancedSettings,
        flowPlayerType = _this$props.flowPlayerType;
      if (flowPlayerType !== 'flow') {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Global",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showOneElementPerPage))), ' ', "Show one element per page")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showRequiredState))), " Show required state as an asterisk to respondents")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showQuestionNumbers))), ' ', "Show question numbers")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showAdvancedSettings))), ' ', "Show advanced settings")));
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        submitting = _this$props2.submitting;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, this._renderTemplateBlock(), this._renderPlayerBlock(), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        onClick: handleSubmit,
        isLoading: submitting
      })));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  valid: _propTypes["default"].bool,
  values: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  settings: _propTypes["default"].object,
  flowPlayerType: _propTypes["default"].string
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'flowSettingsForm',
  fields: fields,
  validate: validate
})(Form);